import { Box, Skeleton } from '@mui/material';
import { colors } from 'styles/colors';

interface TrendingSkeletonProps {
  count?: number;
}

const TrendingSkeleton = ({ count = 4 }: TrendingSkeletonProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5,
        mt: '45px',
      }}
    >
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          width: '70%',
          height: 40,
          background: 'white',
          zIndex: 999,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Skeleton animation="wave" variant="circular" width={18} height={18} />
        <Skeleton animation="wave" height={18} width={180} />
      </Box>

      {[...Array(count)].map((_, index) => (
        <Box
          key={index}
          sx={{
            background: colors.background.approxAliceBlue,
            borderRadius: 2,
            overflow: 'hidden',
          }}
        >
          {/* Image */}
          <Skeleton
            animation="wave"
            variant="rectangular"
            height={130}
            width="100%"
          />

          <Box sx={{ p: 1.5 }}>
            {/* Category + Time */}
            <Box sx={{ display: 'flex', gap: 1, mb: 0.5 }}>
              <Skeleton animation="wave" height={14} width={60} />
              <Skeleton animation="wave" height={14} width={40} />
            </Box>

            {/* Title */}
            <Skeleton animation="wave" height={18} width="90%" />

            {/* Description */}
            <Skeleton animation="wave" height={14} width="100%" />
            <Skeleton animation="wave" height={14} width="80%" />

            {/* Source + Icon */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mt: 1,
              }}
            >
              <Skeleton animation="wave" height={14} width={80} />
              <Skeleton animation="wave" variant="circular" width={14} height={14} />
            </Box>
          </Box>
        </Box>
      ))}
    </Box>
  );
};

export default TrendingSkeleton;
